import axios from 'axios'

import { useAuthStore } from '@/stores/authStore'

const api = axios.create({
  baseURL: import.meta.env.VITE_API,
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().idToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await useAuthStore.getState().signOut()
    }
    return Promise.reject(error)
  }
)

export default api
